"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = assemblyFactory;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _jsonStableStringify = _interopRequireDefault(require("json-stable-stringify"));

var _mobxStateTree = require("mobx-state-tree");

var _abortablePromiseCache = _interopRequireDefault(require("abortable-promise-cache"));

var _configuration = require("../configuration");

var _util = require("../util");

var _QuickLRU = _interopRequireDefault(require("../util/QuickLRU"));

var _excluded = ["signal", "statusCallback"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

// Based on the UCSC Genome Browser chromosome color palette:
// https://github.com/ucscGenomeBrowser/kent/blob/a50ed53aff81d6fb3e34e6913ce18578292bc24e/src/hg/inc/chromColors.h
// Some colors darkened to have at least a 3:1 contrast ratio on a white
// background
var refNameColors = ['rgb(153, 102, 0)', 'rgb(102, 102, 0)', 'rgb(153, 153, 30)', 'rgb(204, 0, 0)', 'rgb(255, 0, 0)', 'rgb(255, 0, 204)', 'rgb(165, 132, 132)', // originally 'rgb(255, 204, 204)'
'rgb(204, 122, 0)', // originally rgb(255, 153, 0)'
'rgb(178, 142, 0)', // originally 'rgb(255, 204, 0)'
'rgb(153, 153, 0)', // originally 'rgb(255, 255, 0)'
'rgb(122, 153, 0)', // originally 'rgb(204, 255, 0)'
'rgb(0, 165, 0)', // originally 'rgb(0, 255, 0)'
'rgb(53, 128, 0)', 'rgb(0, 0, 204)', 'rgb(96, 145, 242)', // originally 'rgb(102, 153, 255)'
'rgb(107, 142, 178)', // originally 'rgb(153, 204, 255)'
'rgb(0, 165, 165)', // originally 'rgb(0, 255, 255)'
'rgb(122, 153, 153)', // originally 'rgb(204, 255, 255)'
'rgb(153, 0, 204)', 'rgb(204, 51, 255)', 'rgb(173, 130, 216)', // originally 'rgb(204, 153, 255)'
'rgb(102, 102, 102)', 'rgb(145, 145, 145)', // originally 'rgb(153, 153, 153)'
'rgb(142, 142, 142)', // originally 'rgb(204, 204, 204)'
'rgb(142, 142, 107)', // originally 'rgb(204, 204, 153)'
'rgb(96, 163, 48)' // originally 'rgb(121, 204, 61)'
];

function loadRefNameMap(_x, _x2, _x3, _x4) {
  return _loadRefNameMap.apply(this, arguments);
} // Valid refName pattern from https://samtools.github.io/hts-specs/SAMv1.pdf


function _loadRefNameMap() {
  _loadRefNameMap = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee4(assembly, adapterConf, options, signal) {
    var sessionId, refNames, refNameAliases, refNameMap, reversed;
    return _regenerator.default.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            sessionId = options.sessionId;
            _context4.next = 3;
            return (0, _util.when)(function () {
              return Boolean(assembly.regions && assembly.refNameAliases);
            }, {
              signal: signal,
              name: 'when assembly ready'
            });

          case 3:
            _context4.next = 5;
            return assembly.rpcManager.call(sessionId, 'CoreGetRefNames', _objectSpread({
              adapterConfig: adapterConf,
              signal: signal
            }, options), {
              timeout: 1000000
            });

          case 5:
            refNames = _context4.sent;
            refNameAliases = assembly.refNameAliases;

            if (refNameAliases) {
              _context4.next = 9;
              break;
            }

            throw new Error("error loading assembly ".concat(assembly.name, "'s refNameAliases"));

          case 9:
            refNameMap = Object.fromEntries(refNames.map(function (name) {
              checkRefName(name);
              return [assembly.getCanonicalRefName(name), name];
            })); // make the reversed map too

            reversed = Object.fromEntries(Object.entries(refNameMap).map(function (_ref2) {
              var _ref3 = (0, _slicedToArray2.default)(_ref2, 2),
                  canonicalName = _ref3[0],
                  adapterName = _ref3[1];

              return [adapterName, canonicalName];
            }));
            return _context4.abrupt("return", {
              forwardMap: refNameMap,
              reverseMap: reversed
            });

          case 12:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  }));
  return _loadRefNameMap.apply(this, arguments);
}

function checkRefName(refName) {
  if (!refName.match(/[0-9A-Za-z!#$%&+./:;?@^_|~-][0-9A-Za-z!#$%&*+./:;=?@^_|~-]*/)) {
    throw new Error("Encountered invalid refName: \"".concat(refName, "\""));
  }
}

function getAdapterId(adapterConf) {
  return (0, _jsonStableStringify.default)(adapterConf);
}

function assemblyFactory(assemblyConfigType, pluginManager) {
  var adapterLoads = new _abortablePromiseCache.default({
    cache: new _QuickLRU.default({
      maxSize: 1000
    }),
    fill: function fill(args, abortSignal, statusCallback) {
      return (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee() {
        var adapterConf, self, options;
        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                adapterConf = args.adapterConf, self = args.self, options = args.options;
                return _context.abrupt("return", loadRefNameMap(self, adapterConf, _objectSpread(_objectSpread({}, options), {}, {
                  statusCallback: statusCallback
                }), abortSignal));

              case 2:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    }
  });
  return _mobxStateTree.types.model({
    configuration: _mobxStateTree.types.safeReference(assemblyConfigType)
  }).volatile(function () {
    return {
      error: undefined,
      regions: undefined,
      refNameAliases: undefined,
      cytobands: undefined
    };
  }).views(function (self) {
    return {
      get initialized() {
        return !!self.refNameAliases;
      },

      get name() {
        return (0, _configuration.getConf)(self, 'name');
      },

      get aliases() {
        return (0, _configuration.getConf)(self, 'aliases');
      },

      hasName: function hasName(name) {
        return this.allAliases.includes(name);
      },

      get allAliases() {
        return [this.name].concat((0, _toConsumableArray2.default)(this.aliases));
      },

      get refNames() {
        var _self$regions;

        return (_self$regions = self.regions) === null || _self$regions === void 0 ? void 0 : _self$regions.map(function (region) {
          return region.refName;
        });
      },

      get allRefNames() {
        return !self.refNameAliases ? undefined : Object.keys(self.refNameAliases);
      },

      get rpcManager() {
        return (0, _mobxStateTree.getParent)(self, 2).rpcManager;
      },

      get refNameColors() {
        var colors = (0, _configuration.getConf)(self, 'refNameColors');

        if (colors.length === 0) {
          return refNameColors;
        }

        return colors;
      }

    };
  }).views(function (self) {
    return {
      getCanonicalRefName: function getCanonicalRefName(refName) {
        if (!self.refNameAliases) {
          throw new Error('aliases not loaded, we expect them to be loaded before getCanonicalRefName can be called');
        }

        return self.refNameAliases[refName];
      },
      getRefNameColor: function getRefNameColor(refName) {
        var _self$refNames;

        var idx = (_self$refNames = self.refNames) === null || _self$refNames === void 0 ? void 0 : _self$refNames.findIndex(function (r) {
          return r === refName;
        });

        if (idx === undefined || idx === -1) {
          return undefined;
        }

        return self.refNameColors[idx % self.refNameColors.length];
      },
      isValidRefName: function isValidRefName(refName) {
        if (!self.refNameAliases) {
          throw new Error('isValidRefName cannot be called yet, the assembly has not finished loading');
        }

        return !!this.getCanonicalRefName(refName);
      }
    };
  }).actions(function (self) {
    return {
      setLoading: function setLoading() {},
      setLoaded: function setLoaded(_ref) {
        var adapterRegionsWithAssembly = _ref.adapterRegionsWithAssembly,
            refNameAliases = _ref.refNameAliases,
            cytobands = _ref.cytobands;
        this.setRegions(adapterRegionsWithAssembly);
        this.setRefNameAliases(refNameAliases);
        this.setCytobands(cytobands);
      },
      setError: function setError(e) {
        console.error(e);
        self.error = e;
      },
      setRegions: function setRegions(regions) {
        self.regions = regions;
      },
      setRefNameAliases: function setRefNameAliases(refNameAliases) {
        self.refNameAliases = refNameAliases;
      },
      setCytobands: function setCytobands(cytobands) {
        self.cytobands = cytobands;
      },
      afterAttach: function afterAttach() {
        (0, _util.makeAbortableReaction)( // eslint-disable-next-line @typescript-eslint/no-explicit-any
        self, // @ts-ignore
        makeLoadAssemblyData(pluginManager), loadAssemblyReaction, {
          name: "".concat(self.name, " assembly loading"),
          fireImmediately: true
        }, this.setLoading, this.setLoaded, this.setError);
      }
    };
  }).views(function (self) {
    return {
      getAdapterMapEntry: function getAdapterMapEntry(adapterConf, options) {
        var signal = options.signal,
            statusCallback = options.statusCallback,
            rest = (0, _objectWithoutProperties2.default)(options, _excluded);

        if (!options.sessionId) {
          throw new Error('sessionId is required');
        }

        var adapterId = getAdapterId(adapterConf);
        return adapterLoads.get(adapterId, {
          adapterConf: adapterConf,
          self: self,
          options: rest
        }, signal, statusCallback);
      },

      /**
       * get Map of `canonical-name -> adapter-specific-name`
       */
      getRefNameMapForAdapter: function getRefNameMapForAdapter(adapterConf, opts) {
        var _this = this;

        return (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2() {
          var map;
          return _regenerator.default.wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  if (!(!opts || !opts.sessionId)) {
                    _context2.next = 2;
                    break;
                  }

                  throw new Error('sessionId is required');

                case 2:
                  _context2.next = 4;
                  return _this.getAdapterMapEntry(adapterConf, opts);

                case 4:
                  map = _context2.sent;
                  return _context2.abrupt("return", map.forwardMap);

                case 6:
                case "end":
                  return _context2.stop();
              }
            }
          }, _callee2);
        }))();
      },

      /**
       * get Map of `adapter-specific-name -> canonical-name`
       */
      getReverseRefNameMapForAdapter: function getReverseRefNameMapForAdapter(adapterConf, opts) {
        var _this2 = this;

        return (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee3() {
          var map;
          return _regenerator.default.wrap(function _callee3$(_context3) {
            while (1) {
              switch (_context3.prev = _context3.next) {
                case 0:
                  _context3.next = 2;
                  return _this2.getAdapterMapEntry(adapterConf, opts);

                case 2:
                  map = _context3.sent;
                  return _context3.abrupt("return", map.reverseMap);

                case 4:
                case "end":
                  return _context3.stop();
              }
            }
          }, _callee3);
        }))();
      }
    };
  });
}

function makeLoadAssemblyData(pluginManager) {
  return function (self) {
    if (self.configuration) {
      // use full configuration instead of snapshot of the config, the
      // rpcManager normally receives a snapshot but we bypass rpcManager here
      // to avoid spinning up a webworker
      var _self$configuration = self.configuration,
          sequence = _self$configuration.sequence,
          refNameAliases = _self$configuration.refNameAliases,
          cytobands = _self$configuration.cytobands;
      var sequenceAdapterConfig = sequence.adapter;
      var refNameAliasesAdapterConfig = refNameAliases === null || refNameAliases === void 0 ? void 0 : refNameAliases.adapter;
      var cytobandAdapterConfig = cytobands === null || cytobands === void 0 ? void 0 : cytobands.adapter;
      return {
        sequenceAdapterConfig: sequenceAdapterConfig,
        assemblyName: self.name,
        refNameAliasesAdapterConfig: refNameAliasesAdapterConfig,
        cytobandAdapterConfig: cytobandAdapterConfig,
        pluginManager: pluginManager
      };
    }

    return undefined;
  };
}

function loadAssemblyReaction(_x5, _x6) {
  return _loadAssemblyReaction.apply(this, arguments);
}

function _loadAssemblyReaction() {
  _loadAssemblyReaction = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee5(props, signal) {
    var sequenceAdapterConfig, assemblyName, refNameAliasesAdapterConfig, cytobandAdapterConfig, pluginManager, adapterRegions, adapterRegionsWithAssembly, refNameAliases, aliases, cytobands;
    return _regenerator.default.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            if (props) {
              _context5.next = 2;
              break;
            }

            return _context5.abrupt("return");

          case 2:
            sequenceAdapterConfig = props.sequenceAdapterConfig, assemblyName = props.assemblyName, refNameAliasesAdapterConfig = props.refNameAliasesAdapterConfig, cytobandAdapterConfig = props.cytobandAdapterConfig, pluginManager = props.pluginManager;
            _context5.next = 5;
            return getAssemblyRegions(sequenceAdapterConfig, pluginManager, signal);

          case 5:
            adapterRegions = _context5.sent;
            adapterRegionsWithAssembly = adapterRegions.map(function (adapterRegion) {
              checkRefName(adapterRegion.refName);
              return _objectSpread(_objectSpread({}, adapterRegion), {}, {
                assemblyName: assemblyName
              });
            });
            refNameAliases = {};
            _context5.next = 10;
            return getRefNameAliases(refNameAliasesAdapterConfig, pluginManager, signal);

          case 10:
            aliases = _context5.sent;
            _context5.next = 13;
            return getCytobands(cytobandAdapterConfig, pluginManager);

          case 13:
            cytobands = _context5.sent;
            aliases.forEach(function (_ref4) {
              var refName = _ref4.refName,
                  aliases = _ref4.aliases;
              aliases.forEach(function (alias) {
                checkRefName(alias);
                refNameAliases[alias] = refName;
              });
            }); // add identity to the refNameAliases list

            adapterRegionsWithAssembly.forEach(function (region) {
              refNameAliases[region.refName] = region.refName;
            });
            return _context5.abrupt("return", {
              adapterRegionsWithAssembly: adapterRegionsWithAssembly,
              refNameAliases: refNameAliases,
              cytobands: cytobands
            });

          case 17:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5);
  }));
  return _loadAssemblyReaction.apply(this, arguments);
}

function getRefNameAliases(_x7, _x8, _x9) {
  return _getRefNameAliases.apply(this, arguments);
}

function _getRefNameAliases() {
  _getRefNameAliases = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee6(config, pluginManager, signal) {
    var _type$getAdapterClass;

    var type, CLASS, adapter;
    return _regenerator.default.wrap(function _callee6$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            type = pluginManager.getAdapterType(config.type);
            _context6.next = 3;
            return (_type$getAdapterClass = type.getAdapterClass) === null || _type$getAdapterClass === void 0 ? void 0 : _type$getAdapterClass.call(type);

          case 3:
            CLASS = _context6.sent;
            adapter = new CLASS(config, undefined, pluginManager);
            return _context6.abrupt("return", adapter.getRefNameAliases({
              signal: signal
            }));

          case 6:
          case "end":
            return _context6.stop();
        }
      }
    }, _callee6);
  }));
  return _getRefNameAliases.apply(this, arguments);
}

function getCytobands(_x10, _x11) {
  return _getCytobands.apply(this, arguments);
}

function _getCytobands() {
  _getCytobands = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee7(config, pluginManager) {
    var type, CLASS, adapter;
    return _regenerator.default.wrap(function _callee7$(_context7) {
      while (1) {
        switch (_context7.prev = _context7.next) {
          case 0:
            type = pluginManager.getAdapterType(config.type);
            _context7.next = 3;
            return type.getAdapterClass();

          case 3:
            CLASS = _context7.sent;
            adapter = new CLASS(config, undefined, pluginManager); // @ts-ignore

            return _context7.abrupt("return", adapter.getData());

          case 6:
          case "end":
            return _context7.stop();
        }
      }
    }, _callee7);
  }));
  return _getCytobands.apply(this, arguments);
}

function getAssemblyRegions(_x12, _x13, _x14) {
  return _getAssemblyRegions.apply(this, arguments);
}

function _getAssemblyRegions() {
  _getAssemblyRegions = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee8(config, pluginManager, signal) {
    var type, CLASS, adapter;
    return _regenerator.default.wrap(function _callee8$(_context8) {
      while (1) {
        switch (_context8.prev = _context8.next) {
          case 0:
            type = pluginManager.getAdapterType(config.type);
            _context8.next = 3;
            return type.getAdapterClass();

          case 3:
            CLASS = _context8.sent;
            adapter = new CLASS(config, undefined, pluginManager);
            return _context8.abrupt("return", adapter.getRegions({
              signal: signal
            }));

          case 6:
          case "end":
            return _context8.stop();
        }
      }
    }, _callee8);
  }));
  return _getAssemblyRegions.apply(this, arguments);
}